export const templateMadeItHub = String.raw`<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>Made it — Nemonto</title>
<link rel="preconnect" href="https://fonts.googleapis.com">
<link href="https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:ital,wght@0,400;0,500;0,600;0,700;1,400&display=swap" rel="stylesheet">
<style>
  :root{
    --spice:#D85A30; --spice-deep:#B23D18; --cream:#FAECE7; --peach:#F5C4B3;
    --charcoal:#2C2C2A; --herb:#1D9E75; --gold:#FAC775; --muted:#8A7A72;
    --serif:'DM Serif Display', Georgia, serif; --sans:'DM Sans', system-ui, sans-serif;
  }
  *{margin:0;padding:0;box-sizing:border-box;}
  body{background:#F1E4DE; color:var(--charcoal); font-family:var(--sans); font-size:14px; height:100vh; overflow:hidden;}
  a{color:inherit; text-decoration:none;}
  button{font-family:inherit; cursor:pointer; border:none; background:none;}
  :focus-visible{outline:2.5px solid var(--spice); outline-offset:2px; border-radius:4px;}
  ::-webkit-scrollbar{width:7px;}
  ::-webkit-scrollbar-thumb{background:rgba(44,44,42,0.14); border-radius:10px;}
  ::-webkit-scrollbar-track{background:transparent;}

  .app{display:grid; grid-template-columns:264px minmax(0,1fr) 300px; height:100vh; width:100%; max-width:none; margin:0;}

  /* ============ LEFT SIDEBAR ============ */
  .sidebar{padding:26px 18px; display:flex; flex-direction:column; height:100vh; border-right:1px solid rgba(44,44,42,0.07);}
  .brand{display:flex; align-items:center; gap:9px; font-family:var(--serif); font-size:21px; padding:0 10px 28px;}
  .nav-item{display:flex; align-items:center; gap:13px; padding:11px 12px; border-radius:14px; width:100%; font-size:15px; font-weight:500; color:#6B5F58; transition:background .15s, color .15s;}
  .nav-item:hover{background:rgba(44,44,42,0.04);}
  .nav-item.active{background:var(--spice); color:var(--cream);}
  .nav-icon{width:21px; height:21px; flex-shrink:0; display:flex; align-items:center; justify-content:center;}
  .nav-badge{margin-left:auto; background:var(--gold); color:#5A3A00; font-size:10.5px; font-weight:700; padding:2px 7px; border-radius:20px;}
  .nav-item.active .nav-badge{background:rgba(250,236,231,0.25); color:var(--cream);}
  .post-btn{margin:18px 10px 22px; background:var(--spice); color:var(--cream); padding:13px; border-radius:16px; font-size:14.5px; font-weight:700; display:flex; align-items:center; justify-content:center; gap:8px; transition:transform .15s, box-shadow .15s;}
  .post-btn:hover{transform:translateY(-1px); box-shadow:0 10px 22px rgba(216,90,48,0.3);}
  .sidebar-spacer{flex:1;}
  .profile-mini{display:flex; align-items:center; gap:10px; padding:9px 10px; border-radius:14px;}
  .pm-avatar{width:38px; height:38px; border-radius:50%; background:#9FE1CB; flex-shrink:0;}
  .pm-name{font-size:13.5px; font-weight:600;}
  .pm-handle{font-size:11.5px; color:#9A8C84;}
  .pm-more{margin-left:auto; color:#9A8C84;}

  /* ============ CENTER ============ */
  .main-col{height:100vh; overflow-y:auto; border-right:1px solid rgba(44,44,42,0.07);}

  .page-header{
    position:sticky; top:0; z-index:5; background:rgba(241,228,222,0.94); backdrop-filter:blur(8px);
    padding:22px 28px 0; border-bottom:1px solid rgba(44,44,42,0.06);
  }
  .ph-title{font-family:var(--serif); font-size:24px; margin-bottom:4px;}
  .ph-sub{font-size:13px; color:#9A8C84; margin-bottom:18px;}

  .view-tabs{display:flex; gap:24px;}
  .view-tab{padding-bottom:13px; font-size:13.5px; font-weight:600; color:#9A8C84; position:relative; display:flex; align-items:center; gap:7px;}
  .view-tab.active{color:var(--spice-deep);}
  .view-tab.active::after{content:''; position:absolute; bottom:0; left:0; right:0; height:2.5px; background:var(--spice); border-radius:2px;}
  .vt-count{background:rgba(44,44,42,0.06); font-size:10.5px; font-weight:700; padding:1px 7px; border-radius:20px; color:#6B5F58;}
  .view-tab.active .vt-count{background:rgba(216,90,48,0.14); color:var(--spice-deep);}

  .body-wrap{padding:22px 28px 60px; max-width:none;}

  .reply-composer{display:flex; gap:10px; align-items:center; background:#fff; border-radius:30px; padding:8px 8px 8px 16px; margin-bottom:22px; border:1px solid rgba(44,44,42,0.06);}
  .reply-composer input{flex:1; border:none; outline:none; background:none; font-size:13.5px; font-family:var(--sans); color:var(--charcoal);}
  .reply-composer input::placeholder{color:#B6A89F;}
  .reply-submit{background:var(--spice); color:#fff; font-size:12.5px; font-weight:700; padding:10px 18px; border-radius:24px;}

  .filter-row{display:flex; gap:7px; margin-bottom:18px; flex-wrap:wrap;}
  .filter-pill{font-size:12px; font-weight:600; padding:7px 13px; border-radius:20px; background:#fff; border:1px solid rgba(44,44,42,0.1); color:#6B5F58;}
  .filter-pill.active{background:var(--spice); color:#fff; border-color:var(--spice);}

  /* made-it card */
  .madeit-card{background:#fff; border-radius:20px; padding:16px; margin-bottom:16px; border:1px solid rgba(44,44,42,0.06);}
  .madeit-card.is-winner{border:2px solid var(--gold); background:rgba(250,199,117,0.05);}

  .source-chip{
    display:inline-flex; align-items:center; gap:7px; background:#F8EFEB; border-radius:30px; padding:5px 12px 5px 6px;
    margin-bottom:12px; font-size:11.5px; color:#6B5F58;
  }
  .source-thumb{width:22px; height:22px; border-radius:50%; flex-shrink:0; display:flex; align-items:center; justify-content:center;}
  .source-chip b{color:var(--spice-deep); font-weight:600;}
  .source-arrow{color:#B6A89F; margin:0 2px;}

  .winner-flag{
    display:flex; align-items:center; gap:7px; background:rgba(250,199,117,0.2); color:#8A5A00; font-size:11.5px;
    font-weight:700; padding:7px 13px; border-radius:20px; margin-bottom:12px;
  }

  .mc-top{display:flex; align-items:center; gap:10px; margin-bottom:11px;}
  .mc-avatar{width:38px; height:38px; border-radius:50%; flex-shrink:0;}
  .mc-name{font-size:13.5px; font-weight:600; display:flex; align-items:center; gap:5px;}
  .mc-time{font-size:11.5px; color:#9A8C84;}
  .mc-reaction{margin-left:auto; font-size:10.5px; font-weight:700; padding:4px 10px; border-radius:20px;}
  .mc-reaction.nailed{background:#E1F5EE; color:#085041;}
  .mc-reaction.twist{background:#FAEEDA; color:#633806;}
  .mc-reaction.almost{background:#F1E4DE; color:#6B5F58;}
  .mc-reaction.tips{background:#EEEDFE; color:#3C3489;}

  .mc-media{height:180px; border-radius:14px; margin-bottom:11px; display:flex; align-items:center; justify-content:center; position:relative;}
  .mc-play{position:absolute; bottom:10px; right:10px; width:34px; height:34px; border-radius:50%; background:rgba(255,255,255,0.92); display:flex; align-items:center; justify-content:center; color:var(--spice-deep);}

  .mc-text{font-size:13.5px; color:#3A3330; line-height:1.55; margin-bottom:12px;}
  .mc-cook-time{display:inline-flex; align-items:center; gap:5px; font-size:11.5px; color:#9A8C84; background:#F8EFEB; padding:4px 10px; border-radius:20px; margin-bottom:12px;}

  .mc-actions{display:flex; align-items:center; gap:18px; padding-top:11px; border-top:1px solid rgba(44,44,42,0.06);}
  .mc-action{display:flex; align-items:center; gap:6px; font-size:12.5px; color:#6B5F58; font-weight:500; cursor:pointer;}
  .mc-action.liked{color:var(--spice-deep);}
  .mc-share{margin-left:auto;}
  .mc-edit-link{font-size:11.5px; color:#9A8C84; font-weight:600;}

  /* empty state */
  .empty-state{text-align:center; padding:60px 20px;}
  .empty-bowl{margin:0 auto 18px; opacity:0.6;}
  .empty-state h3{font-family:var(--serif); font-size:19px; margin-bottom:8px;}
  .empty-state p{font-size:13px; color:#9A8C84; max-width:320px; margin:0 auto 20px; line-height:1.55;}
  .empty-cta{display:inline-block; background:var(--spice); color:#fff; font-size:13px; font-weight:700; padding:11px 24px; border-radius:30px;}

  /* ============ RIGHT RAIL ============ */
  .right-rail{height:100vh; overflow-y:auto; padding:24px 20px 40px;}
  .rail-block{margin-bottom:26px;}
  .rail-head{margin-bottom:14px;}
  .rail-head h3{font-size:13px; font-weight:700; text-transform:uppercase; letter-spacing:0.04em; color:#6B5F58;}

  .streak-card{background:var(--charcoal); border-radius:18px; padding:20px; position:relative; overflow:hidden; text-align:center;}
  .streak-card::before{content:''; position:absolute; top:-50px; right:-40px; width:130px; height:130px; background:radial-gradient(circle, rgba(216,90,48,0.4), transparent 70%);}
  .streak-num{font-family:var(--serif); font-size:38px; color:var(--gold); position:relative; line-height:1;}
  .streak-label{font-size:11.5px; color:rgba(250,236,231,0.7); position:relative; margin-top:4px;}
  .streak-days{display:flex; justify-content:center; gap:6px; margin-top:16px; position:relative;}
  .streak-day{width:22px; height:22px; border-radius:7px; background:rgba(250,236,231,0.1); display:flex; align-items:center; justify-content:center; font-size:10px; color:rgba(250,236,231,0.4);}
  .streak-day.done{background:var(--spice); color:#fff;}

  .stats-grid{display:grid; grid-template-columns:1fr 1fr; gap:10px;}
  .stat-box{background:#fff; border-radius:14px; padding:14px; text-align:center; border:1px solid rgba(44,44,42,0.06);}
  .stat-box b{display:block; font-family:var(--serif); font-size:20px; color:var(--spice-deep);}
  .stat-box span{font-size:10.5px; color:#9A8C84;}

  .reaction-breakdown{background:#fff; border-radius:16px; padding:16px; border:1px solid rgba(44,44,42,0.06);}
  .rb-row{display:flex; align-items:center; gap:10px; margin-bottom:10px;}
  .rb-row:last-child{margin-bottom:0;}
  .rb-label{font-size:12px; color:#6B5F58; width:84px; flex-shrink:0;}
  .rb-bar-wrap{flex:1; height:8px; background:rgba(44,44,42,0.06); border-radius:4px; overflow:hidden;}
  .rb-bar{height:100%; border-radius:4px;}
  .rb-count{font-size:12px; font-weight:600; color:var(--charcoal); width:20px; text-align:right;}

  .top-cuisine-card{background:#fff; border-radius:16px; padding:14px 16px; border:1px solid rgba(44,44,42,0.06); display:flex; align-items:center; gap:12px;}
  .tc-icon{font-size:24px;}
  .tc-text b{font-size:13px; display:block;}
  .tc-text span{font-size:11px; color:#9A8C84;}

  @media (max-width:1180px){
    .app{grid-template-columns:84px minmax(0,1fr) 300px;}
    .brand span.brand-text, .nav-item span.nav-label, .post-btn span.btn-label, .pm-name, .pm-handle{display:none;}
    .nav-item{justify-content:center;} .nav-badge{display:none;} .post-btn{padding:13px;} .profile-mini{justify-content:center;}
  }
  @media (max-width:900px){
    .app{grid-template-columns:84px minmax(0,1fr);}
    .right-rail{display:none;}
  }
</style>
</head>
<body>

<div class="app">

  <!-- ================= LEFT SIDEBAR ================= -->
  <aside class="sidebar">
    <div class="brand">
      <img src="../image/nemonto-logo.png" alt="Nemonto" style="height:32px; width:auto; display:block;" />
    </div>
    <nav>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M4 11l8-7 8 7M6 10v9a1 1 0 001 1h4v-6h2v6h4a1 1 0 001-1v-9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Home</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.8"/><path d="M20 20l-3.5-3.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></span>
        <span class="nav-label">Explore</span>
      </a>
      <a class="nav-item active" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M4 4h16v12H7l-3 3V4z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Made it</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M4 21V5a1 1 0 011-1h14a1 1 0 011 1v16l-8-4-8 4z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Challenges</span>
        <span class="nav-badge">3 live</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M20.8 4.6c-1.5-1.5-4-1.5-5.6.1L12 7.9 8.8 4.7c-1.6-1.6-4.1-1.6-5.6-.1-1.5 1.5-1.5 4 .1 5.6L12 19l8.7-8.8c1.6-1.6 1.6-4.1.1-5.6z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Saved</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M21 11.5a8.4 8.4 0 01-1.2 4.4L21 20l-4.3-1.2a8.5 8.5 0 11-1.8-15.6 8.5 8.5 0 016.1 7.3z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Messages</span>
        <span class="nav-badge">2</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="9" cy="8" r="3.4" stroke="currentColor" stroke-width="1.6"/><path d="M3 19c0-3 2.5-5 6-5s6 2 6 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></span>
        <span class="nav-label">Profile</span>
      </a>
    </nav>
    <div class="post-btn">
      <svg width="17" height="17" viewBox="0 0 20 20" fill="none"><path d="M10 4v12M4 10h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
      <span class="btn-label">New recipe</span>
    </div>
    <div class="sidebar-spacer"></div>
    <div class="profile-mini">
      <div class="pm-avatar"></div>
      <div><div class="pm-name">Priya Rajan</div><div class="pm-handle">@priyacooks</div></div>
      <span class="pm-more">⋯</span>
    </div>
  </aside>

  <!-- ================= CENTER ================= -->
  <main class="main-col">

    <div class="page-header">
      <p class="ph-title">Made it</p>
      <p class="ph-sub">Every dish you've actually cooked — and what the community is making right now.</p>

      <div class="view-tabs" id="viewTabs">
        <div class="view-tab active" data-view="yours">Your made its <span class="vt-count">214</span></div>
        <div class="view-tab" data-view="community">Community feed <span class="vt-count">1.2k today</span></div>
      </div>
    </div>

    <div class="body-wrap">

      <!-- ===== YOUR MADE ITS VIEW ===== -->
      <div class="view-panel" id="panel-yours">

        <div class="filter-row">
          <span class="filter-pill active" data-filter="all">All · 214</span>
          <span class="filter-pill" data-filter="nailed">🔥 Nailed it · 162</span>
          <span class="filter-pill" data-filter="twist">🔄 My twist · 38</span>
          <span class="filter-pill" data-filter="almost">😅 Almost · 14</span>
        </div>

        <!-- winner entry -->
        <div class="madeit-card is-winner" data-reaction="nailed">
          <div class="winner-flag">🏆 This entry won James's challenge</div>
          <div class="source-chip">
            <div class="source-thumb" style="background:#9890DF;"><svg width="12" height="12" viewBox="0 0 100 100"><rect x="22" y="34" width="56" height="42" rx="8" fill="#fff" opacity="0.6"/></svg></div>
            Made from <b>James L.'s</b> "One-pan BBQ flatbread" <span class="source-arrow">→</span>
          </div>
          <div class="mc-top">
            <div class="mc-avatar" style="background:#9FE1CB;"></div>
            <div><div class="mc-name">You</div><div class="mc-time">4 days ago</div></div>
            <span class="mc-reaction nailed">🔥 Nailed it</span>
          </div>
          <div class="mc-media" style="background:linear-gradient(150deg,#9890DF,#534AB7);">
            <svg width="38" height="38" viewBox="0 0 100 100"><rect x="22" y="34" width="56" height="42" rx="8" fill="#fff" opacity="0.6"/></svg>
            <div class="mc-play"><svg width="14" height="14" viewBox="0 0 16 16"><path d="M4 2l10 6-10 6V2z" fill="currentColor"/></svg></div>
          </div>
          <span class="mc-cook-time">⏱ 35 min</span>
          <p class="mc-text">Added smoked paprika — gave it incredible depth. Honestly didn't expect to win against 52 other entries!</p>
          <div class="mc-actions">
            <span class="mc-action liked">♥ 241</span>
            <span class="mc-action">💬 24</span>
            <span class="mc-action mc-share">↗ Share</span>
            <span class="mc-edit-link">Edit</span>
          </div>
        </div>

        <!-- entry 2 -->
        <div class="madeit-card" data-reaction="nailed">
          <div class="source-chip">
            <div class="source-thumb" style="background:#E8916F;"><svg width="12" height="12" viewBox="0 0 100 100"><path d="M18 50 Q18 80 50 80 Q82 80 82 50 Z" fill="#fff" opacity="0.85"/></svg></div>
            Made from <b>Maria K.'s</b> "Cacio e Pepe" <span class="source-arrow">→</span>
          </div>
          <div class="mc-top">
            <div class="mc-avatar" style="background:#9FE1CB;"></div>
            <div><div class="mc-name">You</div><div class="mc-time">Today</div></div>
            <span class="mc-reaction nailed">🔥 Nailed it</span>
          </div>
          <div class="mc-media" style="background:linear-gradient(150deg,#E8916F,#B23D18);">
            <svg width="38" height="38" viewBox="0 0 100 100"><path d="M18 50 Q18 80 50 80 Q82 80 82 50 Z" fill="#fff" opacity="0.9"/></svg>
            <div class="mc-play"><svg width="14" height="14" viewBox="0 0 16 16"><path d="M4 2l10 6-10 6V2z" fill="currentColor"/></svg></div>
          </div>
          <span class="mc-cook-time">⏱ 12 min</span>
          <p class="mc-text">Used the pasta water trick exactly like Maria said — went from grainy to silky the second time around.</p>
          <div class="mc-actions">
            <span class="mc-action liked">♥ 241</span>
            <span class="mc-action">💬 18</span>
            <span class="mc-action mc-share">↗ Share</span>
            <span class="mc-edit-link">Edit</span>
          </div>
        </div>

        <!-- entry 3 -->
        <div class="madeit-card" data-reaction="twist">
          <div class="source-chip">
            <div class="source-thumb" style="background:#FCD58E;"><svg width="12" height="12" viewBox="0 0 100 100"><path d="M24 48 Q24 70 50 70 Q76 70 76 48 Z" fill="#fff" opacity="0.85"/></svg></div>
            Made from <b>Sofia M.'s</b> "No-knead focaccia" <span class="source-arrow">→</span>
          </div>
          <div class="mc-top">
            <div class="mc-avatar" style="background:#9FE1CB;"></div>
            <div><div class="mc-name">You</div><div class="mc-time">2 days ago</div></div>
            <span class="mc-reaction twist">🔄 My twist</span>
          </div>
          <p class="mc-text">Swapped rosemary for thyme since that's what I had — turned out great, will make again with the original next time.</p>
          <div class="mc-actions">
            <span class="mc-action">♥ 34</span>
            <span class="mc-action">💬 6</span>
            <span class="mc-action mc-share">↗ Share</span>
            <span class="mc-edit-link">Edit</span>
          </div>
        </div>

        <!-- entry 4 -->
        <div class="madeit-card" data-reaction="almost">
          <div class="source-chip">
            <div class="source-thumb" style="background:#6FCBA4;"><svg width="12" height="12" viewBox="0 0 100 100"><circle cx="38" cy="44" r="10" fill="#fff" opacity="0.85"/></svg></div>
            Made from <b>Aisha K.'s</b> "Weeknight curry, 20 min" <span class="source-arrow">→</span>
          </div>
          <div class="mc-top">
            <div class="mc-avatar" style="background:#9FE1CB;"></div>
            <div><div class="mc-name">You</div><div class="mc-time">1 week ago</div></div>
            <span class="mc-reaction almost">😅 Almost</span>
          </div>
          <p class="mc-text">Sauce broke on me — think I had the heat too high. Saving this one to retry on a calmer evening.</p>
          <div class="mc-actions">
            <span class="mc-action">♥ 8</span>
            <span class="mc-action">💬 2</span>
            <span class="mc-action mc-share">↗ Share</span>
            <span class="mc-edit-link">Edit</span>
          </div>
        </div>

      </div>

      <!-- ===== COMMUNITY FEED VIEW ===== -->
      <div class="view-panel" id="panel-community" style="display:none;">

        <div class="filter-row">
          <span class="filter-pill active">Following</span>
          <span class="filter-pill">South Asian</span>
          <span class="filter-pill">Italian</span>
          <span class="filter-pill">BBQ</span>
        </div>

        <div class="madeit-card" data-reaction="nailed">
          <div class="source-chip">
            <div class="source-thumb" style="background:#FCD58E;"><svg width="12" height="12" viewBox="0 0 100 100"><path d="M24 48 Q24 70 50 70 Q76 70 76 48 Z" fill="#fff" opacity="0.85"/></svg></div>
            Made from <b>Sofia M.'s</b> "No-knead focaccia" <span class="source-arrow">→</span>
          </div>
          <div class="mc-top">
            <div class="mc-avatar" style="background:#F5C4B3;"></div>
            <div><div class="mc-name">Chen W.</div><div class="mc-time">12 min ago</div></div>
            <span class="mc-reaction nailed">🔥 Nailed it</span>
          </div>
          <div class="mc-media" style="background:linear-gradient(150deg,#FCD58E,#BA7517);">
            <svg width="38" height="38" viewBox="0 0 100 100"><path d="M24 48 Q24 70 50 70 Q76 70 76 48 Z" fill="#fff" opacity="0.9"/></svg>
            <div class="mc-play"><svg width="14" height="14" viewBox="0 0 16 16"><path d="M4 2l10 6-10 6V2z" fill="currentColor"/></svg></div>
          </div>
          <span class="mc-cook-time">⏱ 90 min</span>
          <p class="mc-text">First time making bread and it actually rose! Sea salt on top was the right call.</p>
          <div class="mc-actions">
            <span class="mc-action">♥ 12</span>
            <span class="mc-action">💬 2</span>
            <span class="mc-action mc-share">↗ Share</span>
          </div>
        </div>

        <div class="madeit-card" data-reaction="twist">
          <div class="source-chip">
            <div class="source-thumb" style="background:#AFA9EC;"><svg width="12" height="12" viewBox="0 0 100 100"><rect x="22" y="34" width="56" height="42" rx="8" fill="#fff" opacity="0.6"/></svg></div>
            Made from <b>James L.'s</b> "Sunday ragù" <span class="source-arrow">→</span>
          </div>
          <div class="mc-top">
            <div class="mc-avatar" style="background:#FAC775;"></div>
            <div><div class="mc-name">Sofia M. 🏅</div><div class="mc-time">38 min ago</div></div>
            <span class="mc-reaction twist">🔄 My twist</span>
          </div>
          <p class="mc-text">Used my sourdough discard to thicken instead of tomato paste. Subtle but noticeable.</p>
          <div class="mc-actions">
            <span class="mc-action">♥ 27</span>
            <span class="mc-action">💬 4</span>
            <span class="mc-action mc-share">↗ Share</span>
          </div>
        </div>

        <div class="madeit-card" data-reaction="nailed">
          <div class="source-chip">
            <div class="source-thumb" style="background:#9FE1CB;"><svg width="12" height="12" viewBox="0 0 100 100"><circle cx="38" cy="44" r="10" fill="#fff" opacity="0.85"/></svg></div>
            Made from <b>Priya R.'s</b> "Dal Tadka with ghee" <span class="source-arrow">→</span>
          </div>
          <div class="mc-top">
            <div class="mc-avatar" style="background:#AFA9EC;"></div>
            <div><div class="mc-name">Tom R.</div><div class="mc-time">1 hr ago</div></div>
            <span class="mc-reaction nailed">🔥 Nailed it</span>
          </div>
          <div class="mc-media" style="background:linear-gradient(150deg,#6FCBA4,#0D6B4E);">
            <svg width="38" height="38" viewBox="0 0 100 100"><circle cx="38" cy="44" r="10" fill="#fff" opacity="0.9"/></svg>
            <div class="mc-play"><svg width="14" height="14" viewBox="0 0 16 16"><path d="M4 2l10 6-10 6V2z" fill="currentColor"/></svg></div>
          </div>
          <span class="mc-cook-time">⏱ 25 min</span>
          <p class="mc-text">Comfort in a bowl is right. Made a double batch, gone already.</p>
          <div class="mc-actions">
            <span class="mc-action liked">♥ 19</span>
            <span class="mc-action">💬 3</span>
            <span class="mc-action mc-share">↗ Share</span>
          </div>
        </div>

      </div>

    </div>
  </main>

  <!-- ================= RIGHT RAIL ================= -->
  <aside class="right-rail">

    <div class="rail-block">
      <div class="streak-card">
        <div class="streak-num">12</div>
        <div class="streak-label">day cooking streak 🔥</div>
        <div class="streak-days">
          <div class="streak-day done">M</div>
          <div class="streak-day done">T</div>
          <div class="streak-day done">W</div>
          <div class="streak-day done">T</div>
          <div class="streak-day done">F</div>
          <div class="streak-day done">S</div>
          <div class="streak-day">S</div>
        </div>
      </div>
    </div>

    <div class="rail-block">
      <div class="rail-head"><h3>Your made it stats</h3></div>
      <div class="stats-grid">
        <div class="stat-box"><b>214</b><span>Total made its</span></div>
        <div class="stat-box"><b>3</b><span>Challenge wins</span></div>
        <div class="stat-box"><b>48</b><span>Different recipes</span></div>
        <div class="stat-box"><b>19</b><span>Creators tried</span></div>
      </div>
    </div>

    <div class="rail-block">
      <div class="rail-head"><h3>Your reactions breakdown</h3></div>
      <div class="reaction-breakdown">
        <div class="rb-row">
          <span class="rb-label">🔥 Nailed it</span>
          <div class="rb-bar-wrap"><div class="rb-bar" style="width:76%; background:#1D9E75;"></div></div>
          <span class="rb-count">162</span>
        </div>
        <div class="rb-row">
          <span class="rb-label">🔄 My twist</span>
          <div class="rb-bar-wrap"><div class="rb-bar" style="width:18%; background:#EF9F27;"></div></div>
          <span class="rb-count">38</span>
        </div>
        <div class="rb-row">
          <span class="rb-label">😅 Almost</span>
          <div class="rb-bar-wrap"><div class="rb-bar" style="width:6%; background:#9A8C84;"></div></div>
          <span class="rb-count">14</span>
        </div>
      </div>
    </div>

    <div class="rail-block">
      <div class="rail-head"><h3>Your top cuisine</h3></div>
      <div class="top-cuisine-card">
        <span class="tc-icon">🍝</span>
        <div class="tc-text"><b>Italian</b><span>89 made its — your most cooked cuisine</span></div>
      </div>
    </div>

  </aside>

</div>

<script>
  document.querySelectorAll('#viewTabs .view-tab').forEach(tab => {
    tab.addEventListener('click', () => {
      document.querySelectorAll('#viewTabs .view-tab').forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      const view = tab.dataset.view;
      document.getElementById('panel-yours').style.display = view === 'yours' ? 'block' : 'none';
      document.getElementById('panel-community').style.display = view === 'community' ? 'block' : 'none';
    });
  });

  document.querySelectorAll('.filter-pill').forEach(pill => {
    pill.addEventListener('click', () => {
      const siblings = pill.closest('.filter-row').querySelectorAll('.filter-pill');
      siblings.forEach(p => p.classList.remove('active'));
      pill.classList.add('active');
      const filter = pill.dataset.filter;
      if(!filter) return;
      const panel = pill.closest('.view-panel');
      panel.querySelectorAll('.madeit-card').forEach(card => {
        card.style.display = (filter === 'all' || card.dataset.reaction === filter) ? 'block' : 'none';
      });
    });
  });

  document.querySelectorAll('.mc-action').forEach(btn => {
    if(btn.textContent.trim().startsWith('♥') || btn.textContent.trim().startsWith('♡')){
      btn.addEventListener('click', () => btn.classList.toggle('liked'));
    }
  });
</script>

</body>
</html>

`;
